/* eslint-disable no-throw-literal */
import {
  GET_STEPUP_LIST,
  STEPUP_CREATE,
  GET_STEPUP_DETAIL,
  GET_STEPUP_SHOW,
  DELETE_STEPUP,
  STEPUP_UPDATE,
  USER_GET_BY_SHOP,
  CSV_STEPUP_ANSWER,
  IS_STEPUP_ENTRY_EXIST,
  STEPUP_FUTURE_SHOP_CHANGE_CHECK,
  STEPUP_FUTURE_USERTYPE_CHANGE_CHECK
} from './mutation-types'

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_STEPUP_LIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/step_up_entries', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [STEPUP_CREATE] ({ dispatch }, params) {
      const res = await dispatch('apiPost', { url: '/master/step_up_entries', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_STEPUP_DETAIL] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: `/master/step_up_entries/${params.id}/edit`, data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_STEPUP_SHOW] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: `/master/step_up_entries/${params.id}`, data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [DELETE_STEPUP] ({ dispatch }, params) {
      const res = await dispatch('apiDelete', { url: `/master/step_up_entries/${params.data.id}`, data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [STEPUP_UPDATE] ({ dispatch }, params) {
      const res = await dispatch('apiPatch', { url: `/master/step_up_entries/${params.id}`, data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [USER_GET_BY_SHOP] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/users/get_by_shop', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [CSV_STEPUP_ANSWER] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/step_up_answers/csv_download', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [IS_STEPUP_ENTRY_EXIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/step_up_entries/is_exist', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [STEPUP_FUTURE_SHOP_CHANGE_CHECK] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/shop_histories/future_shop_change_check', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [STEPUP_FUTURE_USERTYPE_CHANGE_CHECK] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/usertype_histories/future_usertype_change_check', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    }
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/stepup.js